import React from "react";
import { UsersTable } from "components/table/user_management/users/UsersTable";

const Users = () => {
    return (
        <>
            <UsersTable />
        </>
    );
}

export { Users };